package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetBusinessCategoriesResponseModel(
    @SerialName("categories")
    val categories: List<BusinessCategoryModel> = emptyList()
) : BaseResponseModel()

@Serializable
data class BusinessCategoryModel(
    val id: Long = 0,
    val title: String = "",
    val description: String = "",
    val coverImageUrls: List<String> = emptyList()
)

